function sortNumber(valueA: number, valueB: number) {
  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
}

export default sortNumber;
